import { getEventTransfer } from 'slate-react'

import hljsToPrismLangMap from 'shared/constants/hljsToPrismLangMap';
import { NODE_TYPE as NT } from 'shared/constants/slate';
import { hljsDetectLanguage } from 'shared/helpers';

// Augment this into PrismHighlight for onPaste
// to see if we can guess which programming language
// is being pasted to highlight.
const onPasteGuessSyntax = (e, change, editor) => {
  const { document: doc, startBlock } = change.value;
  if (startBlock.type !== NT.codeLine) {
    return;
  }

  const codeBlock = doc.getParent(startBlock.key);
  if (codeBlock.type !== NT.codeBlock) {
    return;
  }

  const transfer = getEventTransfer(e);
  const text = (transfer.type === 'fragment'
    ? transfer.fragment.getTexts().map(t => t.text).join('\n')
    : transfer.text
  );

  const hljsLang = hljsDetectLanguage(text);
  const prismLang = hljsToPrismLangMap[hljsLang];
  if (!prismLang) {
    // Means hljs couldn't even guess what language this might be.
    return;
  }

  change.setNodeByKey(codeBlock.key, {
    data: { syntax: prismLang },
  });

  return;
};


export default onPasteGuessSyntax;



// WEBPACK FOOTER //
// ./src/components/slate/plugins/onPasteGuessSyntax.js